import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	selector: 'kwo-already-active-message',
	templateUrl: './already-active-message.component.html',
	styleUrls: ['./already-active-message.component.scss'],
	standalone: true,
	imports: [CommonModule, TranslateModule],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class AlreadyActiveMessageComponent implements OnInit {

	constructor(private router: Router) { }

	ngOnInit(): void {
	}

	goToLogin() {

		this.router.navigate(['inloggen']);
	}

	goToPasswordReset() {

		this.router.navigate(['wachtwoord-reset']);
	}

}
